/* global $*/
import React, { Component } from 'react';

// import { firebaseAuth } from 'config/firebaseConfig'

import {
    onWindowResize,
    onWindowScroll,
    onWindowLoad,
    siteReflow,
    wowInit,
} from 'modules/plugins'

import App from 'components/app/App';

class AppContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authed: false,
            loading: false,
        };
    }

    componentDidMount() {
        console.log('Event::AppCont:mounted')
        require('modules/script')

        siteReflow()

        window.addEventListener('resize', onWindowResize)
        window.addEventListener('scroll', onWindowScroll)
        window.addEventListener('load', onWindowLoad)

        wowInit()

        // this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
        //     if (user) {
        //         this.setState({
        //             authed: true,
        //             loading: false,
        //         })
        //     } else {
        //         this.setState({
        //             authed: false,
        //             loading: false
        //         })
        //     }
        // })
    }

    componentDidUpdate() {
        console.log('Event::AppCont:update')
        setTimeout(() => {
            siteReflow()
        })
    }

    componentWillUnmount() {
        // this.removeListener()
    }

    render() {
        return (
            <App appState={this.state}/>
        )
    }
}

export default AppContainer;



// WEBPACK FOOTER //
// ./src/containers/app/AppContainer.jsx